import React, { Component } from 'react';
import { Icon } from 'react-materialize';
import DatePicker from '../date-picker/DatePicker';
import EventUtils from '../../utils/EventUtils';

import './DateIntervalPicker.css';

class DateIntervalPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      beginDate: props.beginDate,
      endDate: props.endDate,
      name: props.name
    };

    this.clear = this.clear.bind(this);
    this._handleBeginDateChange = this._handleBeginDateChange.bind(this);
    this._handleEndDateChange = this._handleEndDateChange.bind(this);
    this._handleDateSearch = this._handleDateSearch.bind(this);
  }

  get beginDate() {
    return this.state.beginDate;
  }

  set beginDate(beginDate) {
    this.setState({ beginDate: beginDate }, () => {
      if (beginDate > this.endDate) {
        this._endDatePicker.date = beginDate;
      }
    });
  }

  get endDate() {
    return this.state.endDate;
  }

  set endDate(endDate) {
    this.setState({ endDate: endDate }, () => {
      if (endDate < this.beginDate) {
        this._beginDatePicker.date = endDate;
      }
    });
  }

  _handleDateSearch(event){
    EventUtils.raiseEvent('change', this.state, this.props);
  }

  clear(reportChange) {
    try{
      this._beginDatePicker.clear(reportChange);
      this._endDatePicker.clear(reportChange);
    }
    catch(e){}
  }

  _handleBeginDateChange(event) {
    this.beginDate = event.detail.date;
  }

  _handleEndDateChange(event) {
    this.endDate = event.detail.date;
  }

  componentWillReceiveProps(props){
    if(this.props !== props){
      this.setState({
        beginDate: props.beginDate,
        endDate: props.endDate,
        name: props.name
      });
    }
  }

  render() {
    const { beginDate, endDate, name, disabled } = this.state;
    
    return (
      <div className="date-interval-picker">
        <DatePicker ref={ element => this._beginDatePicker = element } label="Begin Date" name={ `${name}-begin-date` } date={ beginDate } disabled={ disabled } onChange={ this._handleBeginDateChange } />
        <DatePicker ref={ element => this._endDatePicker = element } label="End Date" name={ `${name}-end-date` } date={ endDate } disabled={ disabled } onChange={ this._handleEndDateChange } />
        <div id={`${name}-date-search`} className="DateSearch" onClick={this._handleDateSearch} >
          <Icon small>search</Icon> 
        </div>
      </div>
    );
  }
}

export default DateIntervalPicker;
